<script>
    import { onMount } from "svelte";

    import {
        PageHead,
        PageLoading,
    } from "../../Components/Common/index.svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import EclipseLogInfo from "./components/EclipseLogInfo.svelte";
    import EclipseLogRequest from "./components/EclipseLogRequest.svelte";
    import EclipseLogResponse from "./components/EclipseLogResponse.svelte";
    import EclipseLogException from "./components/EclipseLogException.svelte";

    import { user } from "../../stores";
    import { showError } from "../../Utils/utilFunctions.svelte";

    export let params = {};

    $: isUserEnableSeeRequest = $user.role >= 20;

    let isLoadingEclipseLog = false,
        eclipseLogData = {};

    onMount(() => {
        if (params.id) loadEclipseLogById(params.id);
    });

    const loadEclipseLogById = async (id) => {
        isLoadingEclipseLog = true;

        await apiMethods.getMethod.getEclipseLogById(id).then(async (res) => {
            if (res.id) {
                eclipseLogData = { ...res };
            } else showError(res.error);
        });

        isLoadingEclipseLog = false;
    };
</script>

{#if isLoadingEclipseLog}
    <PageLoading />
{:else}
    <PageHead title="View Eclipse Log" />

    <div class="relative flex-1">
        <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 mt-4">
            <EclipseLogInfo {eclipseLogData} />

            {#if isUserEnableSeeRequest}
                <EclipseLogRequest request={eclipseLogData.request} />
            {/if}

            <EclipseLogResponse response={eclipseLogData.response} />

            <EclipseLogException exception={eclipseLogData.exception} />
        </div>
    </div>
{/if}
